import { z } from 'zod'

/**
 * The lifecycle state of an invite. Unlike most enums in this folder there is
 * deliberately NO Prisma counterpart: status is *derived* from the invite's
 * timestamps (`acceptedAt` / `revokedAt` / `expiresAt`) in the converter, so a
 * stored status column can never disagree with the timestamps that define it.
 *
 * Precedence when several could apply: ACCEPTED > REVOKED > EXPIRED > PENDING.
 * An accepted invite stays ACCEPTED forever, even once its `expiresAt` passes.
 */
export const INVITE_STATUSES = [
  'PENDING',
  'ACCEPTED',
  'REVOKED',
  'EXPIRED',
] as const

export const inviteStatusSchema = z.enum(INVITE_STATUSES)

export type InviteStatus = z.infer<typeof inviteStatusSchema>
